import React, { useId } from 'react';
import './StudyStreakIcon.css';

const OUTER = '8,2 13,8 8,14 3,8';
const INNER = '8,5 10.5,8 8,11 5.5,8';

/**
 * Study streak stat glyph (◈) — hollow-center diamond when lit, outline when inactive.
 */
export default function StudyStreakIcon({ className, active = true, ...props }) {
  const maskId = useId().replace(/:/g, '');
  const stateClass = active ? 'study-streak-icon--lit' : 'study-streak-icon--dim';

  return (
    <svg
      className={['study-streak-icon', stateClass, className].filter(Boolean).join(' ')}
      viewBox="3 2 10 12"
      aria-hidden
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {active ? (
        <>
          <defs>
            <mask id={maskId}>
              <polygon points={OUTER} fill="white" />
              <polygon points={INNER} fill="black" />
            </mask>
          </defs>
          <polygon
            className="study-streak-icon__crystal"
            points={OUTER}
            fill="currentColor"
            mask={`url(#${maskId})`}
          />
        </>
      ) : (
        <polygon
          className="study-streak-icon__crystal-outline"
          points={OUTER}
          fill="none"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinejoin="miter"
        />
      )}
    </svg>
  );
}
